export default "/images/single-check.png?26df163072eda126d249953cb6c13673";